export const useFeatureFlags = () => {
  const pcpEnabled = () => {
    const locale = useNuxtApp().$i18n.locale.value
    const { country } = localeConfig[locale]
    const pcpEnabledMarketsConfig = (useRuntimeConfig().public.pcpEnabledMarkets as string) ?? ''
    const pcpEnabledMarkets = pcpEnabledMarketsConfig.split(',')
    return pcpEnabledMarkets.includes(country)
  }

  const jewelleryBuilderEnabled = () => {
    const locale = useNuxtApp().$i18n.locale.value
    const { country } = localeConfig[locale]
    const jewelleryBuilderEnabledMarketsConfig =
      (useRuntimeConfig().public.jewelleryBuilderEnabledMarkets as string) ?? ''
    const jewelleryBuilderEnabledMarkets = jewelleryBuilderEnabledMarketsConfig.split(',')
    return jewelleryBuilderEnabledMarkets.includes(country)
  }

  const bopisEnabled = () => {
    const locale = useNuxtApp().$i18n.locale.value
    const { country } = localeConfig[locale]
    const bopisEnabledMarketsConfig = (useRuntimeConfig().public.bopisEnabledMarkets as string) ?? ''
    const bopisEnabledMarkets = bopisEnabledMarketsConfig.split(',')
    return bopisEnabledMarkets.includes(country)
  }

  /**
   * Generic front-end feature switches.
   * Public runtime variable: NUXT_PUBLIC_FRONTEND_FEATURE_SWITCHES="csv,list,of,flags"
   * Pattern: lightweight, deploy-time controlled, no per-locale scoping.
   */
  const frontendSwitchesRaw = (useRuntimeConfig().public.frontendFeatureSwitches as string) ?? ''
  const frontendSwitches = frontendSwitchesRaw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)

  const hasFrontendFeatureSwitch = (flag: string) => frontendSwitches.includes(flag)

  const productAssociationsEnabled = () => hasFrontendFeatureSwitch('product-associations')

  const clickToPayEnabled = () => hasFrontendFeatureSwitch('click-to-pay') // TODO - remove once done

  const applePayExpressEnabled = () => hasFrontendFeatureSwitch('apple-pay-express')

  const googlePayExpressEnabled = () => hasFrontendFeatureSwitch('google-pay-express')

  const brazePageViewEnabled = () => hasFrontendFeatureSwitch('braze-page-view')

  return {
    pcpEnabled,
    jewelleryBuilderEnabled,
    productAssociationsEnabled,
    clickToPayEnabled,
    applePayExpressEnabled,
    googlePayExpressEnabled,
    bopisEnabled,
    brazePageViewEnabled,
    hasFrontendFeatureSwitch, // expose generic helper for future flags
  }
}
